import { render, staticRenderFns } from "./GettingCoverageAfterMedicareSubguidance.vue?vue&type=template&id=99b38a22&lang=pug"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports